export default __webpack_public_path__ + "static/media/concesionario.aca1fcd2.png";